var map = {
	"./0.png": "B1FD",
	"./1.png": "q9DP",
	"./2.png": "k2hB",
	"./3.png": "+6p+",
	"./4.png": "gBid",
	"./5.png": "2e9S",
	"./6.png": "6Yx6",
	"./7.png": "U3GL",
	"./8.png": "NQFy",
	"./BG.png": "sVcj",
	"./文字.png": "GWox",
	"./返回.png": "o9sg"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "m85e";


//////////////////
// WEBPACK FOOTER
// ./static/image/poster ^\.\/.*\.png$
// module id = m85e
// module chunks = 1